export default "__VITE_ASSET__21a1f45c__"